import React from 'react';
import { createRoot } from 'react-dom/client';

import "~/shared/prefilter";
import ExplanationApp from './containers/ExplanationApp';

import '~/scss/pages/explanation.scss';

createRoot(document.getElementById('explanation-app')).render(
    <ExplanationApp 
        explanationExample = { EXPLANATION_EXAMPLE }
        explanationApiEndpoint = { EXPLANATION_API_ENDPOINT }
    />
);